import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";

const slice = createSlice({
  name: "userStory",
  initialState: {
    stories: {},
    myStories: {},
    storyDetail: {},
    loading: false,
  },
  reducers: {
    storiesRequested: (misc, action) => {
      misc.loading = true;
    },
    storiesReceived: (misc, action) => {
      misc.stories = action.payload;
      misc.loading = false;
    },
    storiesRequestFailed: (misc, action) => {
      misc.loading = false;
    },
    myStoriesRequested: (misc, action) => {
      misc.loading = true;
    },
    myStoriesReceived: (misc, action) => {
      misc.myStories = action.payload;
      misc.loading = false;
    },
    myStoriesRequestFailed: (misc, action) => {
      misc.loading = false;
    },
    storyDetailRequested: (misc, action) => {
      misc.loading = true;
    },
    storyDetailReceived: (misc, action) => {
      misc.storyDetail = action.payload;
      misc.loading = false;
    },
    storyDetailRequestFailed: (misc, action) => {
      misc.loading = false;
    },
  },
});

export const {
  storiesRequested,
  storiesReceived,
  storiesRequestFailed,
  storyDetailRequested,
  storyDetailReceived,
  storyDetailRequestFailed,
  myStoriesReceived,
  myStoriesRequested,
  myStoriesRequestFailed,
} = slice.actions;
export default slice.reducer;

// Action Creators
const baseUrl = "story";

export const getUserStories = (params, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: `stories`,
      params,
      method: "get",
      callback,
      onStart: storiesRequested.type,
      onSuccess: storiesReceived.type,
      onError: storiesRequestFailed.type,
    }),
  );
};

export const getMyStories = (params, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: `my-stories`,
      params,
      method: "get",
      callback,
      onStart: myStoriesRequested.type,
      onSuccess: myStoriesReceived.type,
      onError: myStoriesRequestFailed.type,
    }),
  );
};

export const getUserStoryDetail = (params, id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: `story/${id}`,
      params,
      method: "get",
      callback,
      onStart: storyDetailRequested.type,
      onSuccess: storyDetailReceived.type,
      onError: storyDetailRequestFailed.type,
    }),
  );
};

export const saveUserStory = (data, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: `${baseUrl}`,
      method: "post",
      data,
      callback,
    }),
  );
};

export const updateUserStory = (id, data, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: `${baseUrl}/${id}`,
      method: "put",
      data,
      callback,
    }),
  );
};
export const deleteUserStory = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: `${baseUrl}/${id}`,
      method: "delete",
      callback,
    }),
  );
};
export const userStoryData = createSelector(
  (state) => state.entities.userStory,
  (userStory) => userStory,
);
